import { render, staticRenderFns } from "./ComPalavra.vue?vue&type=template&id=9d75b788&scoped=true&"
import script from "./ComPalavra.vue?vue&type=script&lang=js&"
export * from "./ComPalavra.vue?vue&type=script&lang=js&"
import style0 from "./ComPalavra.vue?vue&type=style&index=0&id=9d75b788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d75b788",
  null
  
)

export default component.exports